import { useCallback } from 'react';

import { getCurrency } from '@/domains/core/settings/utils';
import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { rhinoProductToPrProductMapper } from '@/domains/core/tracking/utils/rhinoProductToPrProductMapper';
import { RhinoProduct } from '@/domains/productDiscovery/ProductPage/interfaces/RhinoProduct';
import {
  UseFingerprintReconciliationTrackClickItem,
  UseFingerprintReconciliationTrackDisplayItem,
  useFingerprintReconciliationTracking,
} from '@/domains/productDiscovery/Recommendation/hooks/useFingerprintReconciliationTracking';

const engineName = 'md_ranking_recommendation';
const eventTrigger = 'product page';

export const useMdRankingPlaylistTracking = (title: string) => {
  const trackDisplayedItem: UseFingerprintReconciliationTrackDisplayItem<RhinoProduct> =
    useCallback(
      ({ itemsWithIndex, reconciliationData }) => {
        const event = {
          amp_event_name: 'Display playlist',
          event: 'interaction_view_item_list',
          event_trigger: eventTrigger,
          number_sp_display: 0,
          page_type: 'product',
          playlist_type: 'natural',
          playlist_name: title,
          playlist_reconciliation: reconciliationData.playlistReconciliation,
          pr_products: itemsWithIndex.map(({ item, itemIndex }) =>
            rhinoProductToPrProductMapper({ item, itemIndex }),
          ),
          reco_engine_name: engineName,
        };

        Gtm.push(event);
      },
      [title],
    );

  const trackClickedItem: UseFingerprintReconciliationTrackClickItem<
    RhinoProduct
  > = ({ reconciliationData, item, itemIndex }) => {
    const event = {
      amp_event_name: 'Click on product card',
      currency: getCurrency(),
      event_trigger: eventTrigger,
      event: 'interaction_product click',
      has_bulk_label: undefined,
      mgr: undefined,
      page_type: 'product',
      playlist_name: title,
      playlist_reconciliation: reconciliationData?.playlistReconciliation,
      pr_products: rhinoProductToPrProductMapper({ item, itemIndex }),
      // B2B only
      has_a_highlighted_product: undefined,
      has_promo_product: item.hasPromoLabel,
      mf_product_count: undefined,
      pro_product_count: undefined,
    };

    Gtm.push(event);
  };

  const data = useFingerprintReconciliationTracking({
    engineTitle: title,
    eventTrigger: 'product page',
    trackDisplayedItem,
    trackClickedItem,
    visibleThreshold: 0.7,
  });

  return data;
};
